import timeclockApi from '../../api/timeclock'

// initial state
const state = {
  punches: [],
}

const getters = {
  currentStatus: (state) => {
    if (state.punches.length > 0) {
      const latest = state.punches.reduce((a,b) => {
        return b.punchTime > a.punchTime ? b : a
      })
      return latest.start ? 'in' : 'out'
    } else {
      return 'no punches'
    }
  },

  sortedPunches: (state) => {
     if (state.punches.length > 0) {
       return state.punches.slice().sort((a,b) => {
         return a.punchTime - b.punchTime
       })
     }
  },
}

const actions = {
  destroy ({ dispatch, commit }, entryId) {
    return new Promise((resolve, reject) => {
      timeclockApi.destroy(entryId, punch => {
        commit('removePunch', punch)
        resolve(punch)
      },
        error => {
          reject(error)
        })
    })
  },

  update ({ dispatch, commit }, idAndFields) {
    return new Promise((resolve, reject) => {
      timeclockApi.update(idAndFields, punch => {
        commit('updatePunch', punch)
        resolve(punch)
      },
        error => {
          reject(error)
        })
    })
  },

  updatePunch ({ commit }, punch) {
    commit('updatePunch', punch)
  },

  managerCreate ({ dispatch, commit }, shiftId) {
    return new Promise((resolve, reject) => {
      timeclockApi.managerCreate(shiftId, punch => {
        commit('updatePunch', punch)
        resolve(punch)
      },
        error => {
          reject(error)
        })
    })
  },

  clockOut ({ commit }, params) {
    return new Promise((resolve, reject) => {
      timeclockApi.clockOut(params, punches => {
        commit('setPunches', punches)
        resolve()
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },

  clockIn ({ commit }, params) {
    return new Promise((resolve, reject) => {
      timeclockApi.clockIn(params, punches => {
        commit('setPunches', punches)
        resolve()
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },

  clockInOverride ({ commit }, params) {
    return new Promise((resolve, reject) => {
      timeclockApi.clockInOverride(params, punches => {
        commit('setPunches', punches)
        resolve()
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },

  clockOutOverride ({ commit }, params) {
    return new Promise((resolve, reject) => {
      timeclockApi.clockOutOverride(params, punches => {
        commit('setPunches', punches)
        resolve()
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },

  getPunches ({ commit }, params) {
    return new Promise((resolve, reject) => {
      timeclockApi.getPunches(params, punches => {
        commit('setPunches', punches)
        resolve()
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },

  getCurrentUserLastPunches ({ commit }) {
    return new Promise((resolve, reject) => {
      timeclockApi.getCurrentUserLastPunches(punches => {
        commit('setPunches', punches)
        resolve()
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },
}

const mutations = {
  setPunches (state, punches) {
    state.punches = punches
  },

  updatePunch (state, punch) {
    state.punches = [
      ...state.punches.filter(p => p.id !== punch.id),
      punch
    ]
  },

  removePunch (state, punch) {
    state.punches = [
      ...state.punches.filter(p => p.id !== punch.id)
    ]
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
